// helper to check if field is true array element and not a checkbox group
const isArrayElement = (field) => field.type === 'ARRAY' && field.uiDisplay?.element !== 'CHECKBOX';

export default isArrayElement;
